import React from "react";
import { Container, Card, Alert, Table } from "react-bootstrap";

export default function CookiePolicy() {
  const effectiveDate = "18/12/2025";

  return (
    <main className="py-5">
      <Container style={{ maxWidth: 900 }}>
        <h1 className="mb-3">Cookie Policy</h1>
        <p className="text-muted">Ultimo aggiornamento: {effectiveDate}</p>

        <Alert variant="secondary" className="mb-4">
          Questo sito utilizza <strong>solo cookie tecnici/necessari</strong>.
          Non usiamo cookie di profilazione/marketing (quindi nessun banner di consenso, per ora).
        </Alert>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">1) Cosa sono i cookie</h2>
            <p className="mb-0">
              I cookie sono piccoli file che il browser salva sul tuo dispositivo. Alcuni sono
              necessari per far funzionare login, sicurezza e funzionalità base.
            </p>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">2) Cookie usati su questo sito</h2>

            <Table bordered responsive className="mt-3">
              <thead>
                <tr>
                  <th>Nome (tipico)</th>
                  <th>Tipo</th>
                  <th>Scopo</th>
                  <th>Durata</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><code>JSESSIONID</code> (o equivalente)</td>
                  <td>Tecnico / sessione</td>
                  <td>Gestione login e sessione utente</td>
                  <td>Sessione (o breve durata)</td>
                </tr>
              </tbody>
            </Table>

            <p className="mb-0 text-muted">
              Il nome esatto può variare in base alla configurazione server.
            </p>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">3) Cookie di terze parti</h2>
            <p className="mb-0">
              Al momento non installiamo cookie di analytics o marketing (es. Google Analytics, Meta Pixel).
              Se verranno aggiunti in futuro, questa policy verrà aggiornata e verrà introdotto il banner consenso.
            </p>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <h2 className="h5">4) Come gestire/disabilitare i cookie</h2>
            <p className="mb-0">
              Puoi bloccare o cancellare i cookie dalle impostazioni del browser. Attenzione:
              disabilitare i cookie tecnici può impedire login e funzioni essenziali.
            </p>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}
